var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostSearchResultList',{attrs:{"posts":_vm.posts,"columns":2},on:{"clicked":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }